/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Layout } from '@/data/types/Layout';
import { FC } from 'react';
import { BrandCategoryLayout } from './aurora/BrandCategoryLayout';
import { IntertoysHomePageLayout } from './aurora/IntertoysHomePageLayout';
import { IntertoysActiePageLayout } from './aurora/IntertoysActiePageLayout';
import { IntertoysHomePageLayout_rv } from './IntertoysHomePageLayout_rv';
import { IntertoysActiesAndFolderLayout1_rv } from './IntertoysActiesAndFolderLayout1_rv';
import { IntertoysActiesAndFolderLayout2_rv } from './IntertoysActiesAndFolderLayout2_rv';
import { IntertoysCategoryBrandPageLayout_rv } from './IntertoysCategoryBrandPageLayout_rv';
import { IntertoysListingPageLayout_rv } from './IntertoysListingPageLayout_rv';
import { IntertoysListingPage4slotLayout_rv } from './IntertoysListingPage4slotLayout_rv';
import { IntertoysProductPageLayout_rv } from './IntertoysProductPageLayout_rv';
import { DepartmentPageLayout } from './aurora/DepartmentPageLayout';
import { ContentPageLayout } from './aurora/ContentPageLayout';
import { SearchLandingPageLayout } from './aurora/SearchLandingPageLayout';
import { SubCategoryPageLayout } from './aurora/SubCategoryPageLayout';
import { IntertoysActiesAndFolderLayout3_rv } from './IntertoysActiesAndFolderLayout3_rv';
import { IntertoysCustomerServiceLayout_rv } from './IntertoysCustomerServiceLayout_rv';

export const layoutManifestCustom: {
	[key: string]: FC<{ layout: Layout }>;
} = {
	BrandCategoryLayout,
	IntertoysHomePageLayout,
	IntertoysActiePageLayout,
	DepartmentPageLayout,
	ContentPageLayout,
	SearchLandingPageLayout,
	SubCategoryPageLayout,
	IntertoysHomePageLayout_rv,
	IntertoysActiesAndFolderLayout1_rv,
	IntertoysCategoryBrandPageLayout_rv,
	IntertoysActiesAndFolderLayout2_rv,
	IntertoysActiesAndFolderLayout3_rv,
	IntertoysCustomerServiceLayout_rv,
	IntertoysListingPageLayout_rv,
	IntertoysListingPage4slotLayout_rv,
	IntertoysProductPageLayout_rv
};